import React from 'react'
import { useSelector } from 'react-redux'
import { selectFirstAddress } from '../../../store/address/address.selectors'
import { selectIsUserAccountEnabled } from '../../../store/userAccount/userAccount.selectors'
import s from '../../address/AddressContent.less'
import sLocationButtons from '../../location/LocationHeaderButtons.less'
import AddressDescription from '../../address/AddressDescription'
import AddressShareButton from '../../address/AddressShareButton'
import { AddressFavoriteButton } from '../../UserAccount/connected/userFavorites/FavoriteButton'
import classNames from 'classnames'
import { TAG_GOTO } from '../../analytics/analytics.tagids.constants'
import LocationItineraryButton from '../../location/LocationItineraryButton'
import { PAGE_ADDRESS_NAME } from '../../analytics/pageTags.constants'

const ZoneContent = ({ titleContent }) => {
  const shouldDisplayFavoriteButton = useSelector(selectIsUserAccountEnabled)
  const address = useSelector(selectFirstAddress)

  return (
    <div className={s.addressContent}>
      <div className={s.mainHeader}>
        {titleContent}
        <div className={classNames(s.actions, sLocationButtons.buttonsSection)}>
          <div className={sLocationButtons.buttonList}>
            <LocationItineraryButton
              location={address}
              tagProps={{
                type: TAG_GOTO,
                tagInfo: {
                  ancrage: PAGE_ADDRESS_NAME,
                },
              }}
            />
            <AddressShareButton />
            {shouldDisplayFavoriteButton && <AddressFavoriteButton />}
          </div>
        </div>
      </div>
      <AddressDescription />
    </div>
  )
}

export default ZoneContent

export const CountryTitle = () => {
  const firstAddress = useSelector(selectFirstAddress)
  return (
    <h1 className={s.addressTitle}>
      <span className={s.locationMainAddress}>{firstAddress?.countryLabel}</span>
    </h1>
  )
}

export const RegionTitle = () => {
  const firstAddress = useSelector(selectFirstAddress)
  return (
    <h1 className={s.addressTitle}>
      <span className={s.locationMainAddress}>{firstAddress?.regionLabel} </span>
      <span className={s.locationSubAddress}>{firstAddress?.regionCode}</span>
    </h1>
  )
}

export const DepartmentTitle = () => {
  const firstAddress = useSelector(selectFirstAddress)
  return (
    <h1 className={s.addressTitle}>
      <span className={s.locationMainAddress}>{firstAddress?.departmentLabel} </span>
      <span className={s.locationSubAddress}>{firstAddress?.departmentCode}</span>
    </h1>
  )
}
